import { LoginComponent } from "@m19-board/auth/login/login.component";
import { RegisterComponent } from "@m19-board/auth/register/register.component";
import { RegisterInviteComponent } from "@m19-board/auth/register/register-invite.component";
import { PasswordResetComponent } from "@m19-board/auth/password-reset/password-reset.component";
import { RequestPasswordResetComponent } from "@m19-board/auth/request-password-reset/request-password-reset.component";
import { TermsOfUseComponent } from "@m19-board/auth/terms-of-use/terms-of-use.component";
import { M19Route } from "@m19-board/utils/M19Route";
import { loggedOutGuard } from "@m19-board/guards/logged-out/logged-out.guard";
import { MarketingFieldResolver } from "@front/m19-services";

export const authRoutes: M19Route[] = [
  {
    path: "login",
    component: LoginComponent,
    title: "Login",
    canActivate: [loggedOutGuard],
  },
  {
    path: "register",
    component: RegisterComponent,
    title: "Register",
    canActivate: [loggedOutGuard],
    resolve: {
      marketingFields: MarketingFieldResolver,
    },
  },
  {
    path: "register-invite",
    component: RegisterInviteComponent,
    title: "Register Invite",
  },
  {
    path: "password-reset",
    component: PasswordResetComponent,
    title: "Reset Password",
  },
  {
    path: "request-password-reset",
    component: RequestPasswordResetComponent,
    title: "Request Password Reset",
  },
  {
    path: "terms-of-use",
    component: TermsOfUseComponent,
    title: "Terms & Conditions",
  },
];
